var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress"},[_c('div',{ref:"progress",class:`progress-bar ${ _vm.getClassColor() }`,style:(`width: ${_vm.currentValue}%`),attrs:{"role":"progressbar","aria-valuenow":_vm.currentValue,"aria-valuemin":"0","aria-valuemax":"100"}},[_vm._v("\n    "+_vm._s(_vm.currentValue)+"%\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }